<div class="container vertical-scroll" cdkDropListGroup>
  <div class="top-portion">
    <ze-execution-container></ze-execution-container>
  </div>
  <div class="main">
    <div class="col left" [ngClass]="{hidePanel : mypanel}">
      <div class="row" style="height: 100%;" *ngIf="suiteListInterface">
        <ze-object-list-main [viewComponent]="this" [listInteface]="suiteListInterface" [active]="false"></ze-object-list-main>
      </div>
    </div>
    <div class="col middle">
      <a [ngClass]="{Arrow1: mypanel, Arrow2: !mypanel}" (click)="paneltoggle()"
        uk-icon="icon: chevron-left; ratio: 2"></a>
      <a [ngClass]="{Arrow2: mypanel, Arrow1: !mypanel}" (click)="paneltoggle()"
        uk-icon="icon: chevron-right; ratio: 2"></a>
      <ng-template #stepview>
        <ze-step-view [rightLeftPanel]="false" [showSaveButton]="false" 
          [stepIdInput]="selectedStepId" (hideStep)="hideStep($event)" (modifyEvent)="modifyEventfn($event)" (stepSaved)="savedInLib()"></ze-step-view>
      </ng-template>
      <ng-template #suites>
        <div class="col middle">
          <div class="canvas">
            <span *ngIf="tabsList.length==0">
              <h1>
                <br />
                <br />
                &nbsp;&nbsp;Please Select any Suite / Step.
              </h1>    
            </span>
            <ze-canvas-component2 [tabsList]="tabsList" [currentIndex]="indexToOpen" (indexRemoved)="spliceTab($event)"
              (indexSelected)="selectedIndexPage($event)" (canvas)="updateCanvas($event)"
              (delete)="deleteCucumberModel($event)" (saveAs)="saveAsModel($event)"></ze-canvas-component2>
          </div>    
        </div>
      </ng-template>
      <ng-container *ngIf="selectedStepId && showStepView" [ngTemplateOutlet]="stepview"></ng-container>
      <ng-container *ngIf="!(selectedStepId && showStepView)" [ngTemplateOutlet]="suites"></ng-container>
    </div>
    <div class="col right" [ngClass]="{hidePanel : mypanel}">
      <div class="row" style="height: 100%;" *ngIf="stepListInterface">
        <ze-object-list-main [viewComponent]="this" [listInteface]="stepListInterface" [showStep]="false" [active]="false">
        </ze-object-list-main>
      </div>
    </div>
  </div>
</div>